<template>
  <div class="page page-car">
    <h3>Создание нового автомобиля</h3>
    <div class="row">
      <div class="col-md-3 mb-2">
        <label>Марка</label>
        <input type="text" class="form-control" v-model="car.brand" placeholder required>
      </div>
      <div class="col-md-4 mb-2">
        <label>Модель</label>
        <input type="text" class="form-control" v-model="car.model" placeholder required>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 mb-2">
        <label>Рег. номер</label>
        <input type="text" class="form-control" v-model="car.registration_plate" placeholder required>
      </div>
      <div class="col-md-2 mb-6">
        <label>Год выпуска</label>
        <input type="text" class="form-control" v-model="car.manufacturing_year" placeholder required>
      </div>
      <div class="col-md-2 mb-6">
        <label>Код радио</label>
        <input type="text" class="form-control" v-model="car.radio_code" placeholder required>
      </div>
    </div>
    <h5 class="py-1">Устройство наблюдения (необязательно)</h5>
    <div class="row">
      <div class="col-md-6 mb-2">
        <label>Название устройства наблюдения</label>
        <input type="text" class="form-control" v-model="devise.trackingDevice.name" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mb-2">
        <label>IMEI</label>
        <input type="text" class="form-control" v-model="devise.trackingDevice.imei" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Тип прошивки</label>
        <v-select
          :options="devise.firmwares"
          v-model="devise.trackingDevice.firmware_id"
          :reduce="firmware => firmware.id"
          label="name"
        />
      </div>
    </div>
    <hr class="mb-4" />
    <button class="btn btn-primary" @click="create()">Создать</button>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapActions } from 'vuex'
import carsAPI from '@/api/cars'
import trackDevicesAPI from '@/api/track-devices'

export default {
  name: 'CreateCar',
  mounted () {
    trackDevicesAPI.getFirmwares().then(response => {
      this.devise.firmwares = response
    })
  },
  data () {
    return {
      isCreating: false,
      car: {
        brand: '',
        model: '',
        registration_plate: '',
        manufacturing_year: '',
        data: 'not fillable now',
        tracking_device_id: null
      },
      devise: {
        firmwares: [],
        trackingDevice: {}
      }
    }
  },
  methods: {
    create () {
      if (this.isCreating) {
        return
      }
      this.isCreating = true
      if (this.devise.trackingDevice.name || this.devise.trackingDevice.imei || this.devise.trackingDevice.firmware_id) {
        trackDevicesAPI.createItem(this.devise.trackingDevice)
          .then(trackDevice => {
            this.isCreating = false
            this.car.tracking_device_id = trackDevice.model.id
            this.createCar()
          })
          .catch(text => {
            this.isCreating = false
            Swal.fire({
              icon: 'error',
              title: 'Ошибка',
              html: text.message
            })
          })
      } else {
        this.createCar()
      }
    },
    createCar () {
      carsAPI.createItem(this.car)
        .then(car => {
          this.isCreating = false
          this.$router.push('/cars')
        })
        .catch(text => {
          this.isCreating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    ...mapActions('taxi/cars', [
      'createItem'
    ])
  }
}
</script>
<style scoped>
  .page-car h3 {
    float: none;
    margin-bottom: 3rem;
  }
  .page-car .btn-primary {
    float: right;
    margin-right: 2rem;
  }
</style>
